import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// hooks
import useAuth from "hooks/useAuth";
import useCustomersTable from "./hooks/useCustomersTable";

// reusable components
import { SecureTableShell } from "@/components/ui/SecureTableShell";
import CustomerSearchControls from "./components/CustomerSearchControls";
import EmptyStateCard from "@/components/ui/EmptyStateCard";

// utils and helpers
import { getFallbackStateCustomers } from "./utils/getFallbackStateCustomers";

const Customers = () => {
  const {
    customerColumns,
    renderCustomerRow,
    allCustomers,
    customers: filteredCustomers,
    searchTerm,
    updateSearchTerm,
    statusFilter,
    updateStatusFilter,
    isError,
    isLoading,
    refetch,
  } = useCustomersTable();

  const { isAuthenticated } = useAuth();

  const [rawSearchTerm, setRawSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const timeout = setTimeout(() => {
      updateSearchTerm(rawSearchTerm);
    }, 600);
    return () => clearTimeout(timeout);
  }, [rawSearchTerm, updateSearchTerm]);

  const fallback = getFallbackStateCustomers({
    isLoading,
    allCustomers,
    filteredCustomers,
  });

  if (!isAuthenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (isError) {
    return (
      <div className="p-6">
        <EmptyStateCard
          icon={
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full">
              <span className="text-red-600 font-bold text-lg">!</span>
            </div>
          }
          title="Something went wrong"
          description="We couldn't load your customers. Please try again or contact support."
          buttonLabel="Retry"
          onAction={refetch}
        />
      </div>
    );
  }

  return (
    <div className="pt-[2em]">
      <CustomerSearchControls
        searchTerm={rawSearchTerm}
        updateSearchTerm={setRawSearchTerm}
      />

      <SecureTableShell
        data={filteredCustomers}
        columns={customerColumns}
        renderRow={renderCustomerRow}
        fallbackState={fallback.state}
      />
    </div>
  );
};

export default Customers;